<button
  id="openDetectBtn"
  [hidden]="true"
  data-toggle="modal"
  data-target="#detectLanding">
</button>

<div class="modal fade"
     id="detectLanding"
     tabindex="-1"
     role="dialog"
     aria-hidden="true"
     data-backdrop="static"
     data-keyboard="false">

  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content"
         style="background-color: #f75a72; align-items: center; padding: 2%; font-weight: 600;">

      <div class="textCenter">
        <h2 class="text-white">
          domiiDetect&#8482;<br/>
          To view your open house guest
        </h2>
      </div>

      <div class="textCenter"
           style="background-color: #fff; padding: 2%; min-width: 99%;">

        <h2 style="color: #f75a72;">
          DOWNLOAD domii<sup>&#174;</sup><br/>
          now and sign in!
        </h2>

        <img
          src="assets/images/download-apple-store.png"
          alt="app store"
          (click)="openAppStore()"
          style="width: 250px"
        /><br/><br/>

        <img
          src="assets/images/download-google-play.png"
          alt="play store"
          (click)="openPlayStore()"
          style="width: 250px"
        />

      </div>
    </div>
  </div>
</div>
